'use strict';

/**
 * Overlay for choosing the set of one or multiple items
 *
 * @category   View
 * @module     collection.Set
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var SelectSetSetsListView = require('../partials/select-set-sets-list');
var SelectSetSetsListItemView = require('../partials/select-set-sets-list-item');

var template = require('modules/collection/modules/set/templates/layout/select-set-overlay.hbs');

var SelectSetOverlayLayout = LayoutView.extend({
    template: template,

    viewData: {
        /**
         * Returns the number of selected items
         * @returns {number}
         */
        selectedObjects: function() {
            return this.getOption('model') || this.collection
                ? this.getOption('model') ? 1 : this.collection.selectedCount()
                : 0;
        },

        /**
         * Returns the current mode
         * @returns {string} The current mode
         */
        mode: function() {
            return this.getOption('mode') === 'select' ? 'select' : 'edit';
        },
    },

    regions: {
        setsRecentRegion: '#region-sets-recent',
        sets0Region: '#region-sets-0',
        sets1Region: '#region-sets-1',
    },

    ui: {
        actionCancel: '[data-action="cancel"]',
        lanesComponent: '.vertical-lanes',
        lane: '.lane',
    },

    events: {
        'click @ui.actionCancel': 'onActionCancel',
        'click @ui.lane': 'onClickLane',
    },

    childEvents: {
        'set:selected': 'onSelectSet',
        'set:goto': 'onGotoSet',
        'set:add': 'onAddSet',
    },

    /**
     * Current level of listing
     * @type {number}
     */
    currentLevel: 0,

    /**
     * Max level
     * @type {number}
     */
    maxLevel: 1,

    /**
     * Should the messenger be showed?
     * @type {boolean}
     */
    showCreateMessage: false,

    /**
     * Refernce for the recent view, for update purposes
     * @type {SetModule.SelectSetSetsListView}
     */
    viewRecent: null,

    onRender: function() {
        var catalog = App.CollectionModule.catalogs.getActiveCatalog();

        // Create default view
        var viewSets = new SelectSetSetsListView({
            collection: catalog.sets,
            childView: SelectSetSetsListItemView,
            level: 0,
            maxLevel: this.maxLevel,
            showCreateMessage: this.getOption('showCreateMessage'),
            sortDefault: 'name.asc',
        });

        // // Listen for changes to update recent
        // this.listenTo(App.CollectionModule.SetModule.setsCollection, 'add', function() {
        //     this.viewRecent.collection = this._getRecentSets();
        //     this.viewRecent.render();
        // }.bind(this));

        // Create recent view, with reference
        this.viewRecent = new SelectSetSetsListView({
            itemLimit: 5,
            collection: catalog.sets,
            childView: SelectSetSetsListItemView,
            isRecent: true,
            showCreateMessage: this.getOption('showCreateMessage'),
            sortDefault: 'modifiedTime.desc',
        });

        // Show in regions
        this.sets0Region.show(viewSets);
        this.setsRecentRegion.show(this.viewRecent);
    },

    /**
     * Closes the modal
     * @param {object} event The click event from the button
     */
    onActionCancel: function(event) {
        this.trigger('close:modal');
    },

    /**
     * Is triggered, when a lane is clicked. We will go back to the clicked lane
     * @param {object} event The click event
     */
    onClickLane: function(event) {
        var $curTarget = $(event.currentTarget);
        if (this.currentLevel > $curTarget.data('level') && !$(event.target).parents('.list').length) {
            this.setLevel($curTarget.data('level'));
        }
    },

    /**
     * Is triggered, when a view should open a subset
     * We will update the storage information of the selected items
     * @param {SetModule.SelectSetSetsListItemView} childView The child, that triggered the event
     * @param {number}                              level     Level of the childview
     * @param {SetModule.SetModel}                  model     The relevant model
     */
    onGotoSet: function(childView, level, model) {
        this.setLevel(level + 1, model);
    },

    /**
     * Is triggered, when a set has been selected in child view
     * We will update the storage information of the selected items
     * @param {SetModule.SelectSetSetsListItemView} childView The child, that triggered the event
     * @param {SetModule.SetModel}                  model     The relevant model
     */
    onSelectSet: function(childView, model) {
        this.trigger('close:modal', {setModel: model});
    },

    /**
     * Is triggered, when add set has been selected in child view
     * We will update the storage information of the selected items
     * @param {SetModule.SelectSetSetsListItemView} childView The child, that triggered the event
     * @param {number}                              level     Level of the childview
     * @param {SetModule.SetModel}                  model     The relevant model
     */
    onAddSet: function(childView, level, model) {
        // this.setLevel(level + 1, model, true);
    },

    /**
     * Sets a new level for the component
     * @param {number} newLevel The level to set
     * @param {object} model    (Optional) Related model for the new level
     */
    // setLevel: function(newLevel, model, forceAdd) {
    //     if (!_.isBoolean(forceAdd)) {
    //         forceAdd = false;
    //     }

    //     // Destroy other regions
    //     if (newLevel < this.currentLevel) {
    //         var regionName;
    //         for (var i = Math.min(newLevel + 1, this.maxLevel); i <= this.maxLevel; i++) {
    //             regionName = 'storages' + i + 'Region';
    //             this[regionName].empty();
    //         }
    //     }

    //     // Is new level valid?
    //     if (newLevel <= this.maxLevel) {
    //         // Update ui
    //         this.currentLevel = newLevel;
    //         this.ui.lanesComponent.attr('data-level', newLevel);

    //         // Do we have a model?
    //         if (model) {
    //             var subStorageCollection = App.CollectionModule.SetModule.setsCollection.getFilteredCollection(function(collectionModel) {
    //                 return model.get('id') === collectionModel.get('parent');
    //             });

    //             var newRegion = 'storages' + newLevel + 'Region';
    //             var viewStorage = new SelectSetSetsListView({
    //                 collection: subStorageCollection,
    //                 childView: SelectSetSetsListItemView,
    //                 level: newLevel,
    //                 maxLevel: this.maxLevel,
    //                 model: model,
    //                 showCreateMessage: this.getOption('showCreateMessage'),
    //                 forceAdd: forceAdd,
    //             });

    //             this[newRegion].show(viewStorage);
    //         }
    //     }
    // },
});

module.exports = SelectSetOverlayLayout;